module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Boettstein-cf9c9b8e8928f9326c8af6bb379a580b.svg";